import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { SitesTableView } from "./SitesTableView";

export const SitesTableViewField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <SitesTableView key={field.name} readOnly={readOnly} />
        </Form.Item>
    );
};
